import './home.scss'
import React, { useState, useRef } from 'react'
import ModalBS from '../../components/modal/modal'
import Navbar from '../../components/navbar/navbar'
import BreadcrumbSample from '../../components/breadcrumb/breadcrumb'
import api_host from '../../env'

const SearchView = ({
  setSearchedAccountID,
  showSuccessModal,
  setShowSuccessModal,
  setSearchedAccountEmails,
  setsearchedAccountStatus,
  setView,
  history
}) => {
  const newAccntEmailRef = useRef(null)
  const newAccntNameRef = useRef(null)
  const [createAccError, setCreateAccError] = useState(null)
  const [searchAccError, setSearchAccError] = useState(null)
  const [newAccountIDCreated, setNewAccountIDCreated] = useState('')
  const [searchAccID, setSearchAccID] = useState('')
  const [newAccountID, setNewAccountID] = useState('')
  const [newEmail, setNewEmail] = useState('')
  const handleClose = () => setShowSuccessModal(false)

  // create account
  const handleAccountIDChange = ({ currentTarget }) =>
    setNewAccountID(currentTarget.value)
  const handleEmailIDChange = ({ currentTarget }) =>
    setNewEmail(
      currentTarget.value
        .replaceAll(' ', '')
        .replaceAll('\n', '')
        .replaceAll('\t', '')
    )
  // search account
  const handleSearchAccIDChange = ({ currentTarget }) =>
    setSearchAccID(currentTarget.value)

  // Get account
  const handleSearchAccount = () => {
    if (!searchAccID) {
      setSearchAccError('Field is mandatory')
      return
    }
    if (!sessionStorage.getItem('token')) {
      setSearchAccError('User not logged in')
      return
    }
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      }
    }
    fetch(`${api_host}/accounts/${searchAccID}`, config)
      .then(res => res.json())
      .then(data => {
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setSearchAccError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setSearchAccError(data.error)
        } else if (data && data.csionetid && data.emails) {
          setSearchedAccountEmails(data.emails.split(','))
          setSearchedAccountID(data.csionetid)
          setsearchedAccountStatus(data.isactive)
          console.log("from searchView:")
          console.log("searchedAccountStatus = " + data.isactive)
          setSearchAccID('')
          setSearchAccError(null)
          setCreateAccError(null)
          setView('details')
        } else {
          setSearchAccError('Something went wrong')
        }
      })
      .catch(() => setSearchAccError('Something went wrong'))
  }
  const handleCreateAccount = async () => {
    if (!newAccountID || !newEmail) {
      setCreateAccError('Fields are mandatory')
      return
    }
    if (!sessionStorage.getItem('token')) {
      setCreateAccError('User not logged in')
      return
    }
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      },
      body: JSON.stringify({
        csionetid: newAccountID,
        emails: newEmail
      })
    }
    // Create account
    fetch(`${api_host}/accounts`, config)
      .then(res => res.json())
      .then(data => {
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setCreateAccError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setCreateAccError(data.error)
        } else if (data && data.description == 'Success') {
          setCreateAccError(null)
          setSearchAccError(null)
          setShowSuccessModal(true)
          setNewAccountIDCreated(newAccountID)
          setNewAccountID('')
          setNewEmail('')
          if (
            newAccntEmailRef &&
            newAccntEmailRef.current &&
            newAccntEmailRef.current.value
          ) {
            newAccntEmailRef.current.value = ''
          }
          if (
            newAccntNameRef &&
            newAccntNameRef.current &&
            newAccntNameRef.current.value
          ) {
            newAccntNameRef.current.value = ''
          }
        } else {
          setCreateAccError('Something went wrong')
        }
      })
      .catch(() => setCreateAccError('Something went wrong'))
  }
  return (
    <>
      <Navbar />
      <BreadcrumbSample />
      <div className="search-account-wrapper">
        <p className="search-heading heading-text">Search by Account ID</p>
        <div className="search-inner-wrapper">
          <span className="search-accnt-label">Account ID</span>
          <br />
          <label htmlFor="search-account-id"></label>
          <input
            className="search-accnt-input"
            type="search-account-id"
            name="search-account-id"
            id="search-account-id"
            data-testid="search-account-id"
            onChange={handleSearchAccIDChange}
          />
          <button
            className="primary-btn search-accnt-btn"
            onClick={handleSearchAccount}
          >
            View
          </button>
          {searchAccError && <p className="error">{searchAccError}</p>}
        </div>
      </div>
      <div className="new-account-wrapper">
        <p className="new-heading heading-text">Add a new Account</p>
        <div className="new-inner-wrapper">
          <span className="new-accnt-label">Account ID</span>
          <br />
          <label htmlFor="new-account-id"></label>
          <input
            className="new-accnt-input"
            type="new-account-id"
            name="new-account-id"
            data-testid="new-account-id"
            id="new-account-id"
            ref={newAccntNameRef}
            onChange={handleAccountIDChange}
          />
          <br />
          <span className="new-accnt-label">Email IDs (comma separated)</span>
          <br />
          <label htmlFor="new-account-email"></label>
          <textarea
            className="new-accnt-input big-box"
            type="new-account-email"
            name="new-account-email"
            id="new-account-email"
            data-testid="new-account-email"
            ref={newAccntEmailRef}
            onChange={handleEmailIDChange}
          />
          <br />
          {createAccError && <p className="error">{createAccError}</p>}
          <button
            className="primary-btn new-accnt-btn right"
            onClick={() => handleCreateAccount()}
          >
            Submit
          </button>
        </div>
      </div>
      <ModalBS
        show={showSuccessModal}
        handleClose={handleClose}
        modalHeader={<>Success!</>}
        modalBody={
          <>{`Successfully created a new account with account ID: ${newAccountIDCreated}`}</>
        }
        modalFooter={
          <button
            className="primary-btn modal-btn"
            onClick={handleClose}
          >
            OK
          </button>
        }
      ></ModalBS>
      <br></br>
    </>
  )
}

export default SearchView
